import { Card } from "antd";
import React from "react";
import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
const averageClosureTime = [
        { group: 'Support Team A', time: 5 },
        { group: 'Support Team B', time: 3 },
        { group: 'Support Team C', time: 4 },
      ];

const CustomYAxis = ({ tickSize = 5, stroke = "#8884d8", ...props }) => (
    <YAxis tickSize={tickSize} stroke={stroke} {...props} />
  );
const AvgTicketClosure = () => {
  return (
    <Card title="Average Ticket Closure Time for Each Group" className="chart-full">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={averageClosureTime}>
                  <XAxis dataKey="group" />
                  <CustomYAxis />
                  <Tooltip />
                  <Line type="monotone" dataKey="time" stroke="#82ca9d" />
                </LineChart>
              </ResponsiveContainer>
            </Card>
  )
}

export default AvgTicketClosure